export default "__VITE_ASSET__Ds8$B9GR__"